export function envAsNumeric(env_variable: string | undefined, defaultValue?: number): number {
  if(!env_variable) {
    if(defaultValue !== undefined) {
      return defaultValue;
    }
    throw new Error('Environment variable is not defined');
  } else {
    const num = Number(env_variable);
    if(isNaN(num)) {
      throw new Error(`Environment variable is not a valid number: ${env_variable}`);
    }
    return num;
  }
}

export function envAsBoolean(env_variable: string | undefined, defaultValue?: boolean): boolean {
  if(!env_variable) {
    if(defaultValue !== undefined) {
      return defaultValue;
    }
    throw new Error('Environment variable is not defined');
  } else {
    if(env_variable === 'true') {
      return true;
    } else if(env_variable === 'false') {
      return false;
    } else {
      throw new Error(`Environment variable is not a valid boolean: ${env_variable}`);
    }
  }
}

export function envAsString(env_variable: string | undefined, defaultValue?: string): string {
  if(!env_variable) {
    if(defaultValue !== undefined) {
      return defaultValue;
    }
    throw new Error('Environment variable is not defined');
  } else {
    return env_variable;
  }
}
